<template>
  <div class="add-partner">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>管理</BreadcrumbItem>
          <BreadcrumbItem to="/exhibition/index/partner/allpartner">合作医院</BreadcrumbItem>
          <BreadcrumbItem>编辑合作医院</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
    </div>
    <div class="my-item">
      <div class="addpartner">
        <div class="f-tar" style="padding: 20px;">
          <Button @click="$router.push('/exhibition/index/partner/allpartner')">返回</Button>
        </div>
        <div class="addpartner-box">
          <div class="my-modal">
            <div class="my-modal-content">
              <Form ref="formInline" :label-width="100" :model="formInline" :rules="ruleInline">
                <FormItem label="Logo：" :required="true">
                  <div
                    class="my-upload-list"
                    v-for="(item, index) in uploadList"
                    :key="'upload' + index"
                    style="width: 100px;height: 100px;line-height:100px;margin-bottom:0;"
                  >
                    <template v-if="item.status === 'finished'">
                      <img :src="item.url" style="width:100%;height:100%;" />
                      <div class="my-upload-list-cover">
                        <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                        <Icon
                          type="ios-trash-outline"
                          @click.native.stop.prevent="handleRemoveByArr(item)"
                        ></Icon>
                      </div>
                    </template>
                    <template v-else>
                      <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                        <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                      </Spin>
                    </template>
                  </div>
                  <Upload
                    ref="upload"
                    :show-upload-list="false"
                    :default-file-list="defaultList"
                    :on-success="handleSuccess"
                    :format="['jpg','jpeg','png']"
                    :max-size="2048"
                    :headers="formHeaders"
                    :on-format-error="handleFormatError"
                    :on-exceeded-size="handleMaxSize"
                    :before-upload="handleBeforeUpload"
                    type="drag"
                    :action="uploadUrl"
                    multiple
                    style="display: inline-block;width:100px;"
                    v-show="uploadList && uploadList.length < 1"
                  >
                    <div style="width: 100px;height:100px;padding-top:15px;color:rgb(133, 133, 133);">
                      <div style="font-size:25px;">
                        +
                        <p style="font-size:14px;">上传图片</p>
                      </div>
                    </div>
                    <!-- 蒙版 -->
                    <div
                      style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
                      @click.stop="selectType"
                    ></div>
                  </Upload>
                  <p style="font-size:12px;">（图片要求：2M以下的jpg或png，建议比例1:1，建议尺寸400*400px）</p>
                </FormItem>
                <FormItem label="公司名称：" prop="name">
                  <Input v-model="formInline.name" placeholder="请输入公司名称" />
                </FormItem>
                <FormItem label="公司简称：" prop="shortName">
                  <Input v-model="formInline.shortName" placeholder="请输入公司简称" />
                </FormItem>
                <FormItem label="合作项目：" prop="itemName">
                  <Input v-model="formInline.itemName" placeholder="请输入合作项目" />
                </FormItem>
                <FormItem>
                  <Checkbox size="large" v-model="formInline.isShow">
                    <span style="display: inline-block;width: 10px;"></span>开启显示
                  </Checkbox>
                </FormItem>
                <FormItem label="显示顺序：">
                  <InputNumber :min="0" v-model="formInline.showIndex"></InputNumber>
                  <br />
                  <span style="font-size:12px;">(数字越小在您的合作伙伴显示列表中显示越靠前)</span>
                </FormItem>
                <FormItem label="项目介绍：" v-if="false">
                  <RadioGroup v-model="formInline.activityType">
                    <Radio size="large" label="0">文字说明</Radio>
                    <Radio size="large" label="1">图片展示</Radio>
                  </RadioGroup>
                  <div style="margin-top: 20px;">
                    <div v-if="formInline.activityType == 0">
                      <FormItem prop="Introduction">
                        <Input type="textarea" v-model="formInline.Introduction" :rows="8" />
                      </FormItem>
                    </div>
                    <div v-if="formInline.activityType == 1">
                      <div
                        class="my-upload-list"
                        v-for="(item, index) in uploadList2"
                        :key="'upload' + index"
                        style="width: 80px;height: 80px;line-height:80px"
                      >
                        <template v-if="item.status === 'finished'">
                          <img :src="item.url" />
                          <div class="my-upload-list-cover">
                            <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                            <Icon
                              type="ios-trash-outline"
                              @click.native.stop.prevent="handleRemoveByArr2(item)"
                            ></Icon>
                          </div>
                        </template>
                        <template v-else>
                          <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
                            <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                          </Spin>
                        </template>
                      </div>
                      <Upload
                        ref="upload2"
                        :show-upload-list="false"
                        :default-file-list="defaultList2"
                        :on-success="handleSuccess2"
                        :format="['jpg','jpeg','png']"
                        :max-size="2048"
                        :headers="formHeaders"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        :before-upload="handleBeforeUpload2"
                        type="drag"
                        :action="uploadUrl"
                        multiple
                        style="display: inline-block;width:80px;"
                        v-show="uploadList2 && uploadList2.length < limitNum"
                      >
                        <div style="width: 80px;height:80px;padding-top: 7px;">
                          <div>
                            +
                            <p>上传</p>
                          </div>
                        </div>
                        <!-- 蒙版 -->
                        <div
                          style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"
                          @click.stop="selectType2"
                        ></div>
                      </Upload>
                      <p style="font-size: 12px;">(图片要求：2M以下jpg或png的图片，宽度为：750px)</p>
                      <iModal title="View Image" v-model="visible">
                        <img
                          :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'"
                          v-if="visible"
                          style="width: 100%"
                        />
                      </iModal>
                    </div>
                  </div>
                </FormItem>

                <FormItem label="项目介绍：" :required="true">
                  <div class="no-padding">
                    <customComponentCommon v-model="Introduction" :type="commonType" @change="changModal"></customComponentCommon>
                  </div>
                </FormItem>

                <FormItem>
                  <Button
                    type="primary"
                    size="large"
                    :loading="loading"
                    @click="handleSubmit('formInline')"
                    style="width:140px;height:35px;font-size:14px;"
                  >保存</Button>
                  <Button
                    type="primary"
                    @click="$router.push('/exhibition/index/template')"
                    style="width:140px;height:35px;font-size:14px;margin-left:20px;"
                  >预览</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <iModal title="图片查看" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>
    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
    <imgUpload
      @upload:local="uploadLocal2"
      @upload:material="uploadMaterial2"
      :maxCount="10"
      v-model="uploadChooseShowed2"
    />
  </div>
</template>

<script>
let moment = require("moment");
import { mapActions, mapGetters } from "vuex";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";
import imgUpload from "@components/imgUpload/imgUpload.vue";
export default {
  name: "add-case",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      commonType: 2,
      Introduction: [],

      imgName: "",
      loading: false, 
      showModal: false,
      formInline: {
        name: "", // 公司名称
        shortName: "", // 公司简称
        itemName: "", // 合作项目
        isShow: true, // 是否显示
        showIndex: 0, //显示顺序
        activityType: "0",
        Introduction: ""
      },
      ruleInline: {
        // 效验规则
        name: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
        shortName: [
          { required: true, message: "请输入公司简称", trigger: "blur" }
        ],
        itemName: [
          { required: true, message: "请输入合作项目", trigger: "blur" },
          {
            type: "string",
            max: 200,
            message: "合作项目文字说明不能大于200字",
            trigger: "blur"
          }
        ],
        Introduction: [
          { required: true, message: "必填选项", trigger: "blur" },
          {
            type: "string",
            max: 2000,
            message: "公司描述文字说明不能大于2000字",
            trigger: "blur"
          }
        ]
      },
      uploadList: [],
      defaultList: [],
      uploadList2: [],
      defaultList2: [],
      visible: false,
      limitNum: 10, // 图文显示的限制图片个数
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      uploadChooseShowed2: false // 控制文件上传方式的显示和隐藏
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    query() {
      return this.$router.history.current.query;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      editCooperation: "companyModule/editCooperation",
      getCooperationById: "companyModule/getCooperationById",
      transformCustomData: "customComponentModule/transformCustomData",
      transformReqCustomData: "customComponentModule/transformReqCustomData"
    }),
    async init() {
      if (!this.query.id) return;
      this.editData = await this.getCooperationById(this.query.id); 
      this.setData();
    },
    async setData() {
      this.formInline.name = this.editData.name;
      this.formInline.shortName = this.editData.shortName;
      this.formInline.itemName = this.editData.itemName;
      this.formInline.showIndex = this.editData.showIndex || 0;
      this.formInline.activityType = String(this.editData.styleId);
      if (this.editData.logo) {
        this.defaultList = [
          {
            name: this.editData.name,
            url: this.editData.logo,
            status: "finished",
            percentage: 100
          }
        ];
      }
      if (
        this.editData.introduction &&
        this.editData.introduction.indexOf("[") !== -1
      ) {
        this.Introduction = await this.transformCustomData(
          JSON.parse(this.editData.introduction)
        );
      }
      this.uploadList = this.defaultList;
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleSuccess2(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList2 = this.$refs.upload2.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    handleBeforeUpload2() {
      const check = this.uploadList2.length < this.limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${this.limitNum}张图片`);
      }
      console.log("this.uploadList2", this.uploadList2);
      return check;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    handleRemoveByArr2(file) {
      const fileList = this.uploadList2;
      this.uploadList2.splice(fileList.indexOf(file), 1);
    },
    async handleSubmit(name) {
      let form = this.formInline;
      let imgList = this.transfromImgList(this.uploadList);
      let imgList2 = this.transfromImgList(this.uploadList2);
      let time = this.formInline.time
        ? moment(this.formInline.time).format("YYYY-MM-DD")
        : "";
      let valid = await this.validForm(name);
      if (!valid) return;
      if (!(this.uploadList && this.uploadList.length)) {
        this.$Message.error(`请上传公司logo图片`);
        return;
      }
      if (this.formInline.activityType === "1" && imgList2.length === 0) {
        this.$Message.error(`请上传公司描述图片`);
        return;
      }
      // 项目介绍
      let Introduction = await this.transformReqCustomData(this.Introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error(`请设置项目介绍`);
        return;
      }
      let formData = {
        Id: this.query.id,
        SetValues: {
          Name: form.name,
          ShortName: form.shortName,
          ItemName: form.itemName,
          IsShow: form.isShow,
          ShowIndex: form.showIndex,
          Logo: this.uploadList[0].url,
          StyleId: String(form.activityType),
          Introduction: Introduction
        }
      };
      console.log("formData", formData);
      this.loading = true;
      let bool = await this.editCooperation(formData);
      this.loading = false;
      if (bool.successed) {
        this.$router.push("/exhibition/index/partner/allpartner");
        this.$Message.success("修改成功");
      } else {
        this.$Message.error("修改失败，请重新尝试");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.loading = false;
      if (this.$refs["formInline"]) {
        this.$refs["formInline"].resetFields();
      }
      this.uploadList = [];
      this.defaultList = [];
      this.uploadList2 = [];
      this.defaultList2 = [];
      this.formInline.activityType = "0";
      this.$emit("close");
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    selectType2() {
      this.uploadChooseShowed2 = true;
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    uploadLocal2() {
      this.$refs.upload2.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    uploadMaterial2(e) {
      for (let item of e) {
        if (this.uploadList2.length >= 10) {
          this.$Message.warning(`最多上传10张图片`);
          return;
        } else {
          this.uploadList2.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed2 = false;
        }
      }
    },
    
    changModal($event) {
      this.Introduction = $event;
      console.log($event);
    }
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
    if (this.$refs.upload2) {
      this.uploadList2 = this.$refs.upload2.fileList;
    }
  },
  components: {
    imgUpload,
    customComponentCommon
  }
};
</script>

<style lang="scss" scoped>
.addpartner {
  background: #fff;
  &-box {
    padding: 20px 85px 40px;
    max-width: 800px;
  }
}
.my-modal {
  &-content {
    padding-right: 20px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
</style> 